import { FC } from 'react'
import { useGetOne } from 'react-admin'
import { useParams } from 'react-router-dom'
import AutomationRuleWizard from './AutomationRuleWizard'
import { AutomationRuleOut, TriggerConfig, ActionConfig } from '../../types/apiRequests'

const AutomationRuleEdit: FC = () => {
  const { id } = useParams<{ id: string }>()
  const { data: record, isLoading } = useGetOne<AutomationRuleOut>(
    'automation_rule',
    { id: id ?? '' },
    { enabled: !!id },
  )

  if (isLoading || !record) return null

  return (
    <AutomationRuleWizard
      mode="edit"
      recordId={id}
      initialData={{
        // eslint-disable-next-line camelcase
        display_name: record.display_name,
        description: record.description ?? '',
        enabled: record.enabled,
        scope: record.scope,
        // eslint-disable-next-line camelcase
        organization_ids: record.organization_ids ?? [],
        // eslint-disable-next-line camelcase
        scope_tiers: record.scope_tiers ?? [],
        triggers: record.triggers as TriggerConfig[],
        actions: record.actions as ActionConfig[],
        // eslint-disable-next-line camelcase
        cooldown_minutes: record.cooldown_minutes,
      }}
    />
  )
}

export default AutomationRuleEdit
